<template>
  <div>
    <section class="achievements">
      <div class="achievements__header">
        <div class="achievements__header__content">
          <h1>{{ getTranslations.home_achievements }}</h1>
        </div>
      </div>

      <div class="achievements__category" v-for="(val, key) in achievements" :key="key">
        <div class="achievements__category__head">
          <h2>{{ key }}</h2>
        </div>
        <div class="achievements__category__body">
          <div
            :class="[ (values.active === true) ? 'achievements__category__icon' : 'achievements__category__icon achievements__category__icon--inactive' ]"
            v-for="(values, index) in val" :key="index">
            <img :src="values.imgUrl" alt="">
            <h3>{{ values.name }}</h3>
            <div class="progressbar progressbar--small">
              <div class="progressbar__bar" :data-percent="values.percentage"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <button class="goto-top"><img src="static/images/top_icon.png" alt=""></button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'achievements',
  data() {
    return {
      user: 1,
      loading: false,
      userDetails: {},
      achievements: {},
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  mounted() {
    this.$nextTick(() => {
      /* eslint-disable */
      // hide/show scroll button
      $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > 500) {
          $('.goto-top').fadeIn();
        }
        else {
          $('.goto-top').fadeOut();
        }
      });
      $('.goto-top').click(function () {
        $(window).scrollTop(0);
      });
    });
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get(`api/getAchievements?msisdn=${this.user}`).then((response) => {
        if (response.status === 200) {
          this.achievements = response.body.data;
          this.loading = false;
          this.$nextTick(() => {
            this.updateProgressBars();
          });
        }
      });
    },
    updateProgressBars() {
      /* eslint-disable */
      $('.progressbar__bar').each(function (i, obj) {
        var percent = $(obj).data('percent');
        $(obj).width(percent + "%");
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Achievements.vue